/**
 * WHERE "BACK" GOES WHEN THERE IS NOWHERE TO GO BACK TO.
 *
 * The owner, 8 Oct: "the back button doesn't work when opening the product in
 * ad, which suppose to go back to the brand or something defined."
 *
 * He is right and this file's own neighbour already said so — the comment by
 * the brand row reads "'Back' here is `navigate(-1)`, which for a shared link
 * goes nowhere". Everyone arriving from an ad arrives that way: the ad opens
 * the product page as the FIRST page of the session, so there is no previous
 * page inside the shop. `navigate(-1)` then either does nothing at all or
 * walks the person out of the shop and back into Facebook — on the traffic we
 * are paying for.
 *
 * ── HOW WE KNOW THERE IS NOTHING BEHIND US ─────────────────────────────────
 *
 * React Router gives the first entry of a session the key `'default'`, and a
 * key of its own to every entry pushed after it. So `key === 'default'` means
 * "this is where they came in", which is exactly the question, and it is a
 * fact about OUR history rather than a guess from `window.history.length` —
 * that counts the embedding browser's entries too and is useless inside
 * Facebook's in-app view.
 *
 * ── WHERE THEY GO INSTEAD ──────────────────────────────────────────────────
 *
 * The brand's page when the product has a brand, because somebody who tapped
 * an ad for a Daniel Klein watch wants more Daniel Klein watches. Otherwise
 * the shop, which is always somewhere. Never a dead button, and never out of
 * the shop entirely.
 */
import { brandPath } from '../../utils/productBrands';

/**
 * @returns {{ kind: 'history' } | { kind: 'to', to: string }}
 *   `history` — they walked here from somewhere in the shop; go back to it.
 *   `to`      — they arrived here directly; this is the defined destination.
 */
export function backFromHere({ locationKey, basePath = '', brand = null } = {}) {
  const arrivedHere = !locationKey || locationKey === 'default';
  if (!arrivedHere) return { kind: 'history' };
  return { kind: 'to', to: brandPath(basePath, brand) || `${basePath || ''}/shop` };
}
